import axios from 'axios';
import useSWR from 'swr';
import { useCallback, useEffect, useState } from 'react';
import { acquireAccessToken, authRequest } from '../../authConfig';

const env = process.env.REACT_APP_BUILD;
let BASE_URL = '';
if (env && env !== 'prd') {
  BASE_URL = `https://${env}.api.ext.exxonmobil.com`;
} else if (env === 'prd') {
  BASE_URL = 'https://api.ext.exxonmobil.com';
} else {
  BASE_URL = '/';
}

const useGetToken = () => {
  const { data: token } = useSWR('token', acquireAccessToken);
  return token;
};

const getAuthHeader = (token: string) => {
  return { Authorization: `Bearer ${token}` };
};

interface RequestProps {
  api: string;
  payload?: any;
  method?: 'GET' | 'POST';
  id?: string;
}

interface PostProps {
  api: string;
  payload?: any;
}

const useAxiosRequest = ({ api, payload, method }: RequestProps) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const token = useGetToken();

  const fetch = useCallback(() => {
    if (token) {
      setIsLoading(true);
      setError('');
      setData(null);
      axios
        .request({
          baseURL: BASE_URL,
          url: `dashboard/${api}`,
          data: payload,
          method,
          headers: getAuthHeader(token)
        })
        .then((response) => setData(response.data.data))
        .catch((e) => {
          setError(e.response.status.toString());
          if (e.response.status >= 400) {
            authRequest();
          }
        })
        .finally(() => setIsLoading(false));
    }
  }, [token]);

  useEffect(() => {
    fetch();
  }, [token]);

  return { data, error, isLoading, fetch };
};

export const useAxiosRequestWithParams = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const token = useGetToken();

  const fetch = useCallback(
    ({ api, payload, method }: RequestProps) => {
      if (token) {
        setIsLoading(true);
        setError('');
        setData(null);
        axios
          .request({
            baseURL: BASE_URL,
            url: `dashboard/${api}`,
            data: payload,
            method,
            headers: getAuthHeader(token)
          })
          .then((response) => setData(response.data.data))
          .catch((e) => {
            setError(e.response.status.toString());
          })
          .finally(() => setIsLoading(false));
      }
    },
    [token]
  );

  return { data, error, isLoading, token, fetch };
};

export const usePostClient = ({ api, payload }: PostProps) => {
  return useAxiosRequest({ api, method: 'POST', payload });
};

export const useGetClient = (api: string) => {
  return useAxiosRequest({ api, method: 'GET' });
};
